import { ResponsiveCarousel } from "../customplugins/carousel.js";

document.addEventListener("DOMContentLoaded", () => {
    const carouselTrackElement = document.getElementById("carouselTrack");
    if (carouselTrackElement) {
        new ResponsiveCarousel("carouselTrack", {
            loop: true,
            margin: 20,
            nav: true,
            autoplay: true,
            autoplayTimeout: 3000, 
            responsive: {
                0: { items: 1 },
                600: { items: 1 },
                1000: { items: 1 }
            }
        });
    }

    const categoriesElement = document.getElementById("Categories");

    if (categoriesElement) {
        new ResponsiveCarousel("Categories", {
            loop: false,
            margin: 10,
            nav: true,
            responsive: {
                0: { items: 2 },
                600: { items: 3 },
                1000: { items: 4 }
            }
        });
    }

    const bestsellersElement = document.getElementById("bestsellers");

    if (bestsellersElement) {
        new ResponsiveCarousel("bestsellers", {
            loop: false,
            margin: 10,
            nav: true,
            responsive: {
                0: { items: 1 },
                600: { items: 3 },
                1000: { items: 5 }
            }
        });
    }


    const videosliderElement = document.getElementById("videoslider");

    if (videosliderElement) {
        new ResponsiveCarousel("videoslider", {
            loop: true,
            margin: 10,
            nav: true,
            responsive: {
                0: { items: 1 },
                600: { items: 2 },
                1000: { items: 3 }
            }
        });
    }

    const heilightslider = document.getElementById("heilightslider");

    if (heilightslider) {
        new ResponsiveCarousel("heilightslider", {
            loop: false,
            margin: 30,
            nav: true,
            responsive: {
                0: { items: 1.2 },
                600: { items: 2.2 },
                1000: { items: 4 }
            }
        });
    }
    const blogcardfull3 = document.getElementById("blogcardfull3");

    if (blogcardfull3) {
        new ResponsiveCarousel("blogcardfull3", {
            loop: false,
            margin: 10,
            nav: true,
            responsive: {
                0: { items: 1.2 },
                600: { items: 2.2 },
                1000: { items: 3 }
            }
        });
    }
    const CertificationsSlider = document.getElementById("CertificationsSlider");

    if (CertificationsSlider) {
        new ResponsiveCarousel("CertificationsSlider", {
            loop: false,
            margin: 10,
            nav: true,
            responsive: {
                0: { items: 1.2 },
                600: { items: 2.2 },
                1000: { items: 5 }
            }
        });
    }


    const homereviewsection = document.getElementById("homereviewsection");

    if (homereviewsection) {
        new ResponsiveCarousel("homereviewsection", {
            loop: false,
            margin: 10,
            nav: true,
            responsive: {
                0: { items: 1.2 },
                600: { items: 2.2 },
                1000: { items: 3 }
            }
        });
    }


})